import { useState, createContext } from "react";

export const sidebarContext = createContext();

const SidebarProvider = (props) => {
  const [open, setOpen] = useState(false);

  return (
    <sidebarContext.Provider value={{ open, setOpen }}>
      {props.children}
    </sidebarContext.Provider>
  );
};

export default SidebarProvider;
